import request from '@/shared/api/request';

export const restoreDatabase = (databaseUuid: string, image: number): Promise<void> =>
  request({
    url: `/databases/${databaseUuid}/`,
    method: 'POST',
    data: { image, action: 'restore' },
  });
